import { configureStore } from '@reduxjs/toolkit';
// Public
import publicCmsReducer from '../features/public/publicCms-slice';
import publicUserSubscriptionReducer from '../features/public/publicUserSubscription-slice';

// State
import stateAgencyReducer from '../features/state/StateAgency-slice';
import stateAppUserReducer from '../features/state/StateAppUser-slice';
import stateFilingReducer from '../features/state/StateFiling-slice';
import stateAuthRoleReducer from '../features/state/StateAuthRole-slice';
import stateFilingActionReducer from '../features/state/StateFilingAction-slice';
import stateTitleReducer from '../features/state/StateTitle-slice';
import stateChapterReducer from '../features/state/StateChapter-slice';
import stateNotificationReducer from '../features/state/StateNotification-slice';
import stateTaskBoardColumnReducer from '../features/state/StateTaskBoardColumn-slice';
import stateFilingFormTypeReducer from '../features/state/StateFilingFormType-slice';
import stateFilingFormReducer from '../features/state/StateFilingForm-slice';
import stateDraftReducer from '../features/state/StateDraft-slice';
import stateProposedRuleReducer from '../features/state/StateProposedRule-slice';
import stateProposedRuleHistoryReducer from '../features/state/StateProposedRuleHistory-slice';
import stateHearingNoticeReducer from '../features/state/StateHearingNotice-slice';
import stateDocumentTypeReducer from '../features/state/StateDocumentType-slice';
import stateDocumentTypeFilingActionReducer from '../features/state/StateDocumentTypeFilingAction-slice';
import stateNoteTypeReducer from '../features/state/StateNoteType-slice';
import stateDraftNoteReducer from '../features/state/StateDraftNote-slice';
import recordStatusReducer from  '../features/state/StateRecordStatus-slice';
import workflowReducer from '../features/state/StateWorkflow-slice';
import filingWorkflowHistoryReducer from '../features/state/StateFilingWorkflowHistory-slice';
import workflowStatusReducer from '../features/state/StateWorkflowStatus-slice';
import workflowStatusActionReducer from '../features/state/StateWorkflowStatusAction-slice';
import filingRejectReasonReducer from '../features/state/StateFilingRejectReason-slice';
import stateDocketReducer from '../features/state/StateDocket-slice';
import stateEnvironmentReducer from '../features/state/StateEnvironment-slice';
import stateSubscriptionUserReducer from '../features/state/StateSubscriptionUser-slice';
import stateAgencyTitleReducer from '../features/state/StateAgency-Title-slice';

// Api slice if we use the rtk query
import { apiSlice } from '../features/api-slice';

export const store = configureStore({
  reducer: {
    appUser: stateAppUserReducer,
    authRoles: stateAuthRoleReducer,
    publicCms: publicCmsReducer,
    publicUserSubscription: publicUserSubscriptionReducer,
    filings: stateFilingReducer,
    filingFormTypes: stateFilingFormTypeReducer,
    filingForms: stateFilingFormReducer,
    filingActions: stateFilingActionReducer,
    titles: stateTitleReducer,
    chapters: stateChapterReducer,
    agencyTitles: stateAgencyTitleReducer,
    agency: stateAgencyReducer,
    taskBoardColumns: stateTaskBoardColumnReducer,
    notification: stateNotificationReducer,
    draft: stateDraftReducer,
    proposedRule: stateProposedRuleReducer,
    proposedRuleHistory: stateProposedRuleHistoryReducer,
    hearingNotice: stateHearingNoticeReducer,
    documentType: stateDocumentTypeReducer,
    documentTypeFilingAction: stateDocumentTypeFilingActionReducer,
    noteType: stateNoteTypeReducer,
    draftNote: stateDraftNoteReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    recordStatuses: recordStatusReducer,
    workflows: workflowReducer,
    filingWorkflowHistories: filingWorkflowHistoryReducer,
    workflowStatuses: workflowStatusReducer,
    workflowStatusActions: workflowStatusActionReducer,
    filingRejectionReasons: filingRejectReasonReducer,
    docket: stateDocketReducer,
    environment: stateEnvironmentReducer,
    subscriptionUser: stateSubscriptionUserReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(apiSlice.middleware);
  },
  //TODO: Comment this out in development
  // devTools: false,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
